import classNames from 'classnames';

import {useI18n} from '@udemy/i18n';
import {useNavigation} from '@udemy/react-discovery-units';
import {LayoutRange, useViewport, withinOrWiderThan} from '@udemy/react-layout-components';

import styles from './topic-category-menu.module.less';

type TopicItem = {
    name: string;
    slug: string;
};

export const TrendingTopicsMenu = ({topicsList}: {topicsList: TopicItem[]}) => {
    const {range} = useViewport();
    const {gettext} = useI18n();
    if (range && !withinOrWiderThan(range as LayoutRange, 'md')) {
        return null;
    }

    const certificationValue = {
        name: gettext('Certification Preparation'),
        slug: 'certification-preparation',
    };

    const combinedTopicsList = [topicsList[0], certificationValue, ...topicsList.slice(1)];

    return (
        <>
            <div className={styles['topic-category-menu-container']}>
                <p className={styles['topic-category-menu-container-title']}>
                    {gettext('Explore the hottest topics for 2026')}
                </p>

                <div className={styles['topic-category-menu']}>
                    {combinedTopicsList.map((topic, index) => (
                        <TopicCategoryMenuItem key={index} topic={topic} number={index} />
                    ))}
                </div>
            </div>
        </>
    );
};

const TopicCategoryMenuItem = ({topic, number}: {topic: TopicItem; number: number}) => {
    const [_, location] = useNavigation();
    const href = location.pathname + '#' + topic.slug;

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const element = document.getElementById(topic.slug);
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    };
    return (
        <a
            className={styles['topic-category-menu-item']}
            href={href}
            onClick={(e) => handleClick(e)}
        >
            <CategoryNumberIcon number={number + 1} isSmall={true} />
            <h2 className={styles['topic-category-menu-item-text']}>{topic.name}</h2>
        </a>
    );
};

export const CategoryNumberIcon = ({
    number,
    isSmall = false,
    className,
}: {
    number: number | null;
    isSmall?: boolean;
    className?: string;
}) => {
    if (!number) {
        return null;
    }
    return (
        <div
            className={classNames(styles['category-icon'], {
                [styles['category-icon-small']]: isSmall,
                ...(className && {[className]: true}),
            })}
        >
            <span className={styles['category-number']}>{number}</span>
        </div>
    );
};
